export enum MonitoringContentType {
  Load = 'LOAD',
  TO = 'TO',
  Waybill = 'WAYBILL',
  SpecialFreight = 'SPECIAL_FREIGHT',
  DeliveryNote = 'DELIVERY_NOTE',
  HandlingUnit = 'HANDLING_UNIT',
}
